import { Link } from "react-router-dom";
import type { Project } from "@/mocks/projects";

interface ProjectCardProps {
  project: Project;
}

export default function ProjectCard({ project }: ProjectCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 hover:-translate-y-1.5 transition-transform duration-500">
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={project.image}
          alt={`Proyecto ${project.name} en ${project.comuna}`}
          title={`${project.name} - Inmobiliaria ADJ`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span className="rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold px-3 py-1 whitespace-nowrap">
            {project.statusLabel}
          </span>
        </div>
        {project.soldLabel && (
          <span className="absolute bottom-4 left-4 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-semibold px-3 py-1 whitespace-nowrap">
            {project.soldLabel}
          </span>
        )}
      </div>

      <div className="flex flex-col flex-1 p-5 md:p-6 gap-3">
        <div className="flex flex-col gap-1">
          <h3 className="font-heading text-2xl text-foreground-900">{project.name}</h3>
          <p className="text-sm text-foreground-500 flex items-center gap-1.5">
            <i className="ri-map-pin-line text-primary-500" />
            {project.comuna}
          </p>
        </div>

        <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-home-4-line text-primary-500" />
            {project.homes} casas
          </span>
        </div>

        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
          {project.description}
        </p>

        <div className="flex flex-wrap gap-2 mt-auto">
          {project.features.slice(0, 4).map((feature) => (
            <span
              key={feature}
              className="rounded-full bg-background-100 text-foreground-600 text-xs px-3 py-1 whitespace-nowrap"
            >
              {feature}
            </span>
          ))}
        </div>

        <Link
          to={`/proyectos/${project.slug}`}
          className="mt-4 inline-flex items-center justify-center gap-2 rounded-md border border-foreground-900 text-foreground-900 hover:bg-foreground-900 hover:text-background-50 text-sm font-semibold px-5 py-2.5 transition-colors duration-300 whitespace-nowrap"
        >
          Ver proyecto
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </article>
  );
}